import { useHook } from '../../lenteHooks'

export const useCheckEntityRouting = () => {
  const { entity, legalEntityId, tenantId } = useHook(
    'routing.general.useLegalEntityParams',
  )({
    isOptional: true,
  })

  const isParticipantOrPersonRoute = !!(
    tenantId &&
    legalEntityId &&
    entity === 'person'
  )

  const isCompanyRoute = !!(tenantId && legalEntityId && entity === 'company')

  if (isParticipantOrPersonRoute) {
    return { entity, ownerId: legalEntityId, tenantId }
  } else if (isCompanyRoute) {
    return { entity, companyId: legalEntityId, tenantId }
  } else {
    return {}
  }
}
